import { messageError, messageSuccess, messageAlert } from '../../toastr'
import CmdService from '../../../app/service/cmdService';
import { Modal } from 'antd';

const serviceCmd = new CmdService();

export const sendMatch = (plate, slaveNum) => {
    serviceCmd
        .sendMatch({
            "plate": plate,
            "slaveNum": slaveNum,
            "nameCommands": `Casamento com o slave ${slaveNum}`,
        })
        .then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            } else {
                messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
            }
        })
        .catch(erros => {
            if (erros.response.status === 400) {
                messageError(erros.response.data.message);
            } else {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            }
        })
};

export const sendQualification = (plate, slaveNum, type, routeStartStatus) => {

    if (type === "disable/all" && routeStartStatus == "STARTED") {
        Modal.confirm({
            title: "ATENÇÃO! Dispositivo em rota.",
            content: "Este veículo encontra-se com roteirização em curso, e esta ação cancelará tal processo. Deseja realmente prosseguir?",
            okText: "Confirmar",
            cancelText: "Cancelar",
            onOk: () => handleSendQualification(plate, slaveNum, type),
        });
    } else {
        const qualificationData = slaveNum ? {
            "plate": plate,
            "deviceNum": slaveNum,
            "nameCommands": type === "enable/all" ? "Habilitar todos os Slave" : type === "disable/all" ? "Desabilitar todos os Slave" : `Desabilitar o slave ${slaveNum}`,
        } : {
            "plate": plate,
            "nameCommands": type === "enable/all" ? "Habilitar todos os Slave" : type === "disable/all" ? "Desabilitar todos os Slave" : `Habilitar o slave ${slaveNum}`,

        };
        serviceCmd
            .sendQualification(qualificationData, type)
            .then(response => {
                if (response.data.status !== 200) {
                    messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
                } else {
                    messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
                }
            })
            .catch(erros => {
                if (erros.response.status === 400) {
                    messageError(erros.response.data.message);
                } else {
                    messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
                }
            });
    }



};

const handleSendQualification = (plate, slaveNum, type) => {

    const qualificationData = slaveNum ? {
        "plate": plate,
        "deviceNum": slaveNum,
        "nameCommands": type === "enable/all" ? "Habilitar todos os Slave" : type === "disable/all" ? "Desabilitar todos os Slave" : `Desabilitar o slave ${slaveNum}`,
    } : {
        "plate": plate,
        "nameCommands": type === "enable/all" ? "Habilitar todos os Slave" : type === "disable/all" ? "Desabilitar todos os Slave" : `Habilitar o slave ${slaveNum}`,

    };

    serviceCmd
        .sendQualification(qualificationData, type)
        .then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            } else {
                messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
            }
        })
        .catch(erros => {
            if (erros.response.status === 400) {
                messageError(erros.response.data.message);
            } else {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            }
        });
    const data = {
        plate: plate,
    }
    
    serviceCmd.sendRoute(data, "stop").then((response) => {
        if (response.data.status === 200) {
            //messageSuccess("Comando de finalizar rota enviado.");
        } else {
            //messageError("Error ao enviar comando de finalizar rota.");
        }
    }).catch((error) => {
        console.error("Error", error);
    });

}

export const sendBlock = (plate, slaveNum, type) => {
    const blockData = slaveNum ? {
        "plate": plate,
        "slaveNum": slaveNum,
        "nameCommands": type === "block/all" ? "Bloquear todos" : type === "unblock/all" ? "Desbloquear todos" : type === "blocktest/master" ? "Bloqueio Master" : `Bloqueio Slave ${slaveNum}`,

    } : {
        "plate": plate,
        "nameCommands": type === "block/all" ? "Bloquear todos" : type === "unblock/all" ? "Desbloquear todos" : type === "blocktest/master" ? "Bloqueio Master" : `Bloqueio Slave ${slaveNum}`,
    };

    serviceCmd
        .sendBlock(blockData, type)
        .then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            } else {
                messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
            }
        })
        .catch(erros => {
            if (erros.response.status === 400) {
                messageError(erros.response.data.message);
            } else {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            }
        })
};

export const sendRoute = (plate, type) => {
    serviceCmd
        .sendRoute({
            "plate": plate
        }, type)
        .then(response => {
            if (response.data.status !== 200) {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            } else {
                messageSuccess("Comando transmitido. Aguarde a confirmação de efetivação.");
            }
        })
        .catch(erros => {
            if (erros.response.data.status === 400) {
                messageError(erros.response.data.message);
            } else if (erros.response.data.status === 404 && erros.response.data.message === "rota não vinculada") {
                messageAlert("ATENÇÃO! Nenhuma rota vinculada a esta placa!");
            } else {
                messageError("ERRO! Falha no processamento deste comando, favor repetir o processo.");
            }
        })
};